module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"button":"Select","selected":"text selected"},"fr":{"button":"Sélectionner","selected":"texte sélectionné"},"de":{"button":"Wählen","selected":"ausgewählten Text"}}')
  delete Component.options._Ctor
}
